import { keepPreviousData, QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";

import { ApiError, ExtendedAPIParams } from "@/app/lib/definitions";

export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

interface UsePaginatedQueryOptions<T, TData = any> extends Omit<
  UseQueryOptions<PaginatedResponse<T>, ApiError, TData>,
  "queryKey" | "queryFn"
> {
  params?: ExtendedAPIParams;
}

export default function usePaginatedQuery<T, TData = PaginatedResponse<T>>(
  queryKey: QueryKey,
  apiFunction: (params: ExtendedAPIParams) => Promise<PaginatedResponse<T>>,
  options?: UsePaginatedQueryOptions<T, TData>,
) {
  const { params, ...useQueryOptions } = options || {};

  return useQuery<PaginatedResponse<T>, ApiError, TData>({
    queryKey,
    queryFn: () => apiFunction(params || {}),
    placeholderData: keepPreviousData,
    ...useQueryOptions,
  });
}
